<ng-container *ngIf="vm$ | async as vm">
  <div *ngIf="vm.err as err" class="modal fade show d-flex align-items-start justify-content-center em-overlay"
    tabindex="-1" role="dialog" aria-modal="true" aria-label="Global error modal">
    <div class="modal-donation modal-dialog modal-dialog-centered" role="document"
      [class.is-small]="vm.size === 'small'" [class.is-normal]="vm.size === 'normal'"
      [class.is-wide]="vm.size === 'wide'" [class.is-full]="vm.size === 'full'">
      <div class="modal-content border-0 rounded-4 overflow-hidden em-card">
        <!-- Header -->
        <div class="em-header d-flex align-items-start gap-3 p-4">
          <div class="em-icon" aria-hidden="true">!</div>
          <div class="flex-grow-1">
            <h5 class="em-title mb-1">Something went wrong</h5>
            <div class="em-meta small">
              <span>{{ err.time | date: 'medium' }}</span>
              <span *ngIf="err.status"> · Status {{ err.status }}</span>
            </div>
          </div>
          <button type="button" class="btn btn-close ms-auto" aria-label="Close" (click)="close()"></button>
        </div>

        <!-- Body -->
        <div class="em-body px-4 pb-3">
          <p class="em-message mb-3">{{ err.message }}</p>

          <div class="em-badges mb-2">
            <span *ngIf="err.correlationId" class="em-badge">
              <span class="em-badge-label">CorrelationId</span>
              <code>{{ short(err.correlationId) }}</code>
              <button class="em-copy-btn" (click)="copy('correlationId', err.correlationId!)"
                [class.copied]="copied.correlationId">
                <span class="copy-text">Copy</span>
                <span class="copied-text" aria-live="polite">✓ Copied!</span>
              </button>
            </span>

            <span *ngIf="err.traceId" class="em-badge">
              <span class="em-badge-label">TraceId</span>
              <code>{{ short(err.traceId) }}</code>
              <button class="em-copy-btn" (click)="copy('traceId', err.traceId!)" [class.copied]="copied.traceId">
                <span class="copy-text">Copy</span>
                <span class="copied-text" aria-live="polite">✓ Copied!</span>
              </button>
            </span>

            <span *ngIf="err.code && err.code !== 'unexpected_error'" class="em-badge muted">
              <span class="em-badge-label">Code</span>
              <code>{{ err.code }}</code>
            </span>
          </div>

          <details *ngIf="err.url || err.details" class="em-details">
            <summary>Technical details</summary>
            <div class="em-details-inner">
              <div class="em-details-toolbar">
                <div class="muted" *ngIf="err.url">URL: {{ err.url }}</div>
                <button class="em-copy-btn ms-auto" (click)="copy('details', buildDetailsText(err))"
                  [class.copied]="copied.details">
                  <span class="copy-text">Copy details</span>
                  <span class="copied-text" aria-live="polite">✓ Copied!</span>
                </button>
              </div>
              <pre *ngIf="err.details" class="em-code em-scroll"><code>{{ err.details | json }}</code></pre>
            </div>
          </details>
        </div>

        <!-- Footer -->
        <div class="em-footer d-flex align-items-center justify-content-between px-4 py-3">
          <p class="em-footer-note mb-0">
            Share the CorrelationId with support
            <span class="em-mail">{{ supportEmail }}</span>
            if needed.
          </p>
          <button class="btn btn-secondary" (click)="close()">Close</button>
        </div>

      </div>
    </div>
  </div>
</ng-container>